import { c as _c } from "react/compiler-runtime";
import type { RatingStats } from "@/entities/IProfile";
import UserPageRepRepsTableItem from "./UserPageRepRepsTableItem";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageRepRepsTableBody(t0) {
  const $ = _c(11);
  const {
    reps,
    profile,
    canEditRep,
    maxRep
  } = t0;
  let t1;
  if ($[0] !== canEditRep || $[1] !== maxRep || $[2] !== profile || $[3] !== reps) {
    let t2;
    if ($[5] !== canEditRep || $[6] !== maxRep || $[7] !== profile) {
      t2 = rep => <UserPageRepRepsTableItem key={rep.category} rep={rep} profile={profile} canEditRep={canEditRep} maxRep={maxRep} />;
      $[5] = canEditRep;
      $[6] = maxRep;
      $[7] = profile;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = reps.map(t2);
    $[0] = canEditRep;
    $[1] = maxRep;
    $[2] = profile;
    $[3] = reps;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <tbody>{t1}</tbody>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}